var _circle, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _path2, _rect9, _rect0, _rect1, _rect10, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5054,
    cy: 46,
    r: 34,
    fill: "#EFF1F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 21.9145,
    width: 56.5835,
    height: 22.233,
    rx: 6.20928,
    fill: "white",
    stroke: "url(#paint0_angular_526_4564)",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4331,
    y: 28.8252,
    width: 28.0412,
    height: 2.80412,
    rx: 1.40206,
    fill: "#E2E6EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4331,
    y: 35.1343,
    width: 16.8247,
    height: 2.80412,
    rx: 1.40206,
    fill: "#E2E6EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2061,
    y: 26.021,
    width: 14.0206,
    height: 14.0206,
    rx: 3.50515,
    fill: "#35C0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1393 32.6936C18.9325 32.6936 18.7135 32.6815 18.458 32.6333C17.9592 32.537 17.6551 32.2841 17.0467 32.4045C15.7084 32.6695 14.5526 36.4876 16.1951 36.5358C17.0711 36.5598 17.6064 35.5722 18.2755 35.3193C18.458 35.247 18.8109 35.2109 19.1515 35.2109C19.4922 35.2109 19.845 35.247 20.0275 35.3193C20.6966 35.5722 21.232 36.5598 22.1079 36.5358C23.7504 36.4876 22.5946 32.6695 21.2563 32.4045C20.648 32.2841 20.3438 32.549 19.845 32.6333C19.5652 32.6815 19.3462 32.6936 19.1393 32.6936ZM19.1393 29.5259C18.3607 29.5259 17.7281 30.1522 17.7281 30.923C17.7281 31.6939 18.3607 32.3202 19.1393 32.3202C19.918 32.3202 20.5506 31.6939 20.5506 30.923C20.5506 30.1522 19.918 29.5259 19.1393 29.5259Z",
    fill: "white",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 48.5541,
    width: 56.5835,
    height: 22.233,
    rx: 6.20928,
    fill: "white",
    stroke: "url(#paint1_angular_526_4564)",
    strokeWidth: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4331,
    y: 55.4644,
    width: 28.0412,
    height: 2.80412,
    rx: 1.40206,
    fill: "#E2E6EA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4331,
    y: 61.7739,
    width: 16.8247,
    height: 2.80412,
    rx: 1.40206,
    fill: "#E2E6EA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2061,
    y: 52.6602,
    width: 14.0206,
    height: 14.0206,
    rx: 3.50515,
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4641 59.3332C19.2572 59.3332 19.0382 59.3212 18.7827 59.273C18.2839 59.1766 17.9798 58.9237 17.3714 59.0442C16.0331 59.3091 14.8773 63.1272 16.5198 63.1754C17.3958 63.1995 17.9311 62.2118 18.6002 61.9589C18.7827 61.8866 19.1356 61.8505 19.4762 61.8505C19.8169 61.8505 20.1697 61.8866 20.3522 61.9589C21.0213 62.2118 21.5567 63.1995 22.4326 63.1754C24.0751 63.1272 22.9193 59.3091 21.581 59.0442C20.9727 58.9237 20.6685 59.1887 20.1697 59.273C19.8899 59.3212 19.6709 59.3332 19.4641 59.3332ZM19.4641 56.1655C18.6854 56.1655 18.0528 56.7918 18.0528 57.5627C18.0528 58.3335 18.6854 58.9598 19.4641 58.9598C20.2427 58.9598 20.8754 58.3335 20.8754 57.5627C20.8754 56.7918 20.2427 56.1655 19.4641 56.1655Z",
    fill: "white",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3266,
    y: 33.1313,
    width: 56.5835,
    height: 22.233,
    rx: 6.20928,
    fill: "white",
    stroke: "url(#paint2_angular_526_4564)",
    strokeWidth: 0.2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6597,
    y: 40.042,
    width: 28.0412,
    height: 2.80412,
    rx: 1.40206,
    fill: "#E2E6EA"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6597,
    y: 46.3511,
    width: 16.8247,
    height: 2.80412,
    rx: 1.40206,
    fill: "#E2E6EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4326,
    y: 37.2378,
    width: 14.0206,
    height: 14.0206,
    rx: 3.50515,
    fill: "#FEC84B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3659 43.9104C37.1591 43.9104 36.9401 43.8983 36.6846 43.8501C36.1858 43.7538 35.8816 43.5009 35.2733 43.6213C33.935 43.8863 32.7792 47.7044 34.4217 47.7526C35.2976 47.7766 35.833 46.789 36.5021 46.5361C36.6846 46.4638 37.0374 46.4277 37.3781 46.4277C37.7187 46.4277 38.0716 46.4638 38.2541 46.5361C38.9232 46.789 39.4585 47.7766 40.3345 47.7526C41.977 47.7044 40.8212 43.8863 39.4829 43.6213C38.8745 43.5009 38.5704 43.7658 38.0716 43.8501C37.7917 43.8983 37.5727 43.9104 37.3659 43.9104ZM37.3659 40.7427C36.5873 40.7427 35.9546 41.369 35.9546 42.1398C35.9546 42.9107 36.5873 43.537 37.3659 43.537C38.1446 43.537 38.7772 42.9107 38.7772 42.1398C38.7772 41.369 38.1446 40.7427 37.3659 40.7427Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2139 17.1668C69.2139 16.8447 68.9527 16.5835 68.6305 16.5835C68.3084 16.5835 68.0472 16.8447 68.0472 17.1668V17.1668C68.0472 17.4386 68.0472 17.5745 68.0028 17.6817C67.9436 17.8247 67.83 17.9382 67.6871 17.9974C67.5799 18.0418 67.444 18.0418 67.1722 18.0418V18.0418C66.85 18.0418 66.5889 18.303 66.5889 18.6252C66.5889 18.9473 66.85 19.2085 67.1722 19.2085V19.2085C67.444 19.2085 67.5799 19.2085 67.6871 19.2529C67.83 19.3121 67.9436 19.4257 68.0028 19.5686C68.0472 19.6758 68.0472 19.8117 68.0472 20.0835V20.0835C68.0472 20.4057 68.3084 20.6668 68.6305 20.6668C68.9527 20.6668 69.2139 20.4057 69.2139 20.0835V20.0835C69.2139 19.8117 69.2139 19.6758 69.2583 19.5686C69.3175 19.4257 69.431 19.3121 69.574 19.2529C69.6812 19.2085 69.8171 19.2085 70.0889 19.2085V19.2085C70.411 19.2085 70.6722 18.9473 70.6722 18.6252C70.6722 18.303 70.411 18.0418 70.0889 18.0418V18.0418C69.8171 18.0418 69.6812 18.0418 69.574 17.9974C69.431 17.9382 69.3175 17.8247 69.2583 17.6817C69.2139 17.5745 69.2139 17.4386 69.2139 17.1668V17.1668Z",
    fill: "#35C0FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2139 25.9168C69.2139 25.5947 68.9527 25.3335 68.6305 25.3335C68.3084 25.3335 68.0472 25.5947 68.0472 25.9168V25.9168C68.0472 26.1886 68.0472 26.3245 68.0028 26.4317C67.9436 26.5747 67.83 26.6882 67.6871 26.7474C67.5799 26.7918 67.444 26.7918 67.1722 26.7918V26.7918C66.85 26.7918 66.5889 27.053 66.5889 27.3752C66.5889 27.6973 66.85 27.9585 67.1722 27.9585V27.9585C67.444 27.9585 67.5799 27.9585 67.6871 28.0029C67.83 28.0621 67.9436 28.1757 68.0028 28.3186C68.0472 28.4258 68.0472 28.5617 68.0472 28.8335V28.8335C68.0472 29.1557 68.3084 29.4168 68.6305 29.4168C68.9527 29.4168 69.2139 29.1557 69.2139 28.8335V28.8335C69.2139 28.5617 69.2139 28.4258 69.2583 28.3186C69.3175 28.1757 69.431 28.0621 69.574 28.0029C69.6812 27.9585 69.8171 27.9585 70.0889 27.9585V27.9585C70.411 27.9585 70.6722 27.6973 70.6722 27.3752C70.6722 27.053 70.411 26.7918 70.0889 26.7918V26.7918C69.8171 26.7918 69.6812 26.7918 69.574 26.7474C69.431 26.6882 69.3175 26.5747 69.2583 26.4317C69.2139 26.3245 69.2139 26.1886 69.2139 25.9168V25.9168Z",
    fill: "#35C0FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1333 17.5408C74.0467 17.3155 73.8302 17.1668 73.5889 17.1668C73.3475 17.1668 73.1311 17.3155 73.0444 17.5408L72.0328 20.1709C71.8576 20.6265 71.8025 20.7578 71.7272 20.8638C71.6516 20.97 71.5587 21.0629 71.4525 21.1385C71.3465 21.2138 71.2152 21.2689 70.7596 21.4441L68.1295 22.4557C67.9042 22.5424 67.7555 22.7588 67.7555 23.0002C67.7555 23.2415 67.9042 23.458 68.1295 23.5446L70.7596 24.5562C71.2152 24.7315 71.3465 24.7865 71.4525 24.8618C71.5587 24.9374 71.6516 25.0303 71.7272 25.1366C71.8025 25.2425 71.8576 25.3738 72.0328 25.8294L73.0444 28.4596C73.1311 28.6848 73.3475 28.8335 73.5889 28.8335C73.8302 28.8335 74.0467 28.6848 74.1333 28.4596L75.1449 25.8294C75.3202 25.3738 75.3752 25.2425 75.4505 25.1366C75.5261 25.0303 75.619 24.9374 75.7253 24.8618C75.8312 24.7865 75.9625 24.7315 76.4181 24.5562L79.0483 23.5446C79.2735 23.458 79.4222 23.2415 79.4222 23.0002C79.4222 22.7588 79.2735 22.5424 79.0483 22.4557L76.4181 21.4441C75.9625 21.2689 75.8312 21.2138 75.7253 21.1385C75.619 21.0629 75.5261 20.97 75.4505 20.8638C75.3752 20.7578 75.3202 20.6265 75.1449 20.1709L74.1333 17.5408Z",
    fill: "#35C0FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_526_4564",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3918 33.0309) rotate(90) scale(11.2165 28.3918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35C0FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_526_4564",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3918 59.6706) rotate(90) scale(11.2165 28.3918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16B56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_526_4564",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6183 44.2477) rotate(90) scale(11.2165 28.3918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC84B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.77e98fbfa22aeba38779c2f69b9b3bbf01ad98661281d2b981e0efaf7f542dae.svg";
export { ForwardRef as ReactComponent };